import { Injectable } from "@angular/core";
import {
	HttpEvent,
	HttpInterceptor,
	HttpHandler,
	HttpRequest,
	HttpResponse
} from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { Observable } from "rxjs";
import { catchError, tap } from "rxjs/operators";

@Injectable()
export class InterceptService implements HttpInterceptor {
	// intercept request and add token
	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		// modify request
		request = request.clone({
			setHeaders: {
				"origin-site": environment.originSite,
				"client-id": environment.baymax_client_id,
				"client-secret": environment.baymax_client_secret,
				Authorization: `Bearer ${localStorage.getItem("accessToken")}`
			}
		});

		return next.handle(request).pipe(
			tap(
				event => {
					if (event instanceof HttpResponse) {
						// http response status code
						// console.log(event.status);
					}
				},
				error => {
					// http response status code
					console.error(error.status);
					console.error(error.message);
				}
			)
		);
	}
}
